import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { authApi } from "redux/services/auth";
import { walletApi } from "redux/services/wallet";
import { membershipApi } from "redux/services/membership";
import { dataLoaderApi } from "redux/services/dataLoader";
import { documentApi } from "redux/services/documentRepository";
import { auditApi } from "redux/services/auditRecord";
import { reconciliationApi } from "./services/reconciliation";

import {
  indetityApi,
  indetityApiAppToken,
  setPasswordApiAppToken,
} from "redux/services/identity";
import { accountApi } from "redux/services/account";
import rootReducer from "redux/rootReducer";
import { merchantApi } from "./services/merchant";
import { businessActivityApi } from "./services/businessActivity";
import { bankApi } from "./services/bank";
import { enterpriseApi } from "./services/enterprise";
import { paymentApi } from "./services/payment";
import { countryApi } from "./services/country";
import errorMiddleware from "redux/middleware/errorMiddleware";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(
      errorMiddleware,
      authApi.middleware,
      walletApi.middleware,
      membershipApi.middleware,
      dataLoaderApi.middleware,
      documentApi.middleware,
      auditApi.middleware,
      indetityApi.middleware,
      indetityApiAppToken.middleware as any,
      setPasswordApiAppToken.middleware as any,
      accountApi.middleware,
      merchantApi.middleware,
      enterpriseApi.middleware,
      paymentApi.middleware,
      countryApi.middleware,
      businessActivityApi.middleware,
      bankApi.middleware,
      reconciliationApi.middleware,

    ),
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(
        errorMiddleware,
        authApi.middleware,
        walletApi.middleware,
        membershipApi.middleware,
        dataLoaderApi.middleware,
        documentApi.middleware,
        auditApi.middleware,
        indetityApiAppToken.middleware as any,
        setPasswordApiAppToken.middleware as any,
        indetityApi.middleware,
        merchantApi.middleware,
        enterpriseApi.middleware,
        paymentApi.middleware,
      ),
    preloadedState,
  });
};

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = typeof store.dispatch;
